/**
 * @packageDocumentation
 * @module api.functional.orders.note
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponsenull } from "../../../structures/ServiceResponsenull";
import type { UpdateNoteDto } from "../../../structures/UpdateNoteDto";

/**
 * @controller PreorderController.updateNote
 * @path PATCH /orders/:id/note
 * @accessor api.functional.orders.note.updateNote
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function updateNote(
  connection: IConnection,
  id: string,
  customerId: string,
  body: updateNote.Body,
): Promise<updateNote.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...updateNote.METADATA,
      template: updateNote.METADATA.path,
      path: updateNote.path(id, customerId),
    },
    body,
  );
}
export namespace updateNote {
  export type Body = UpdateNoteDto;
  export type Output = ServiceResponsenull;

  export const METADATA = {
    method: "PATCH",
    path: "/orders/:id/note",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string, customerId: string) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries({
      customerId: customerId,
    } as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = `/orders/${encodeURIComponent(id?.toString() ?? "null")}/note`;
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}
